module.exports = __webpack_public_path__ + "assets/website_logo.5ae6c2d2.svg";